<template>
  <div v-if="value" v-bsl="value"></div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import moment from 'moment';

import TeacherSvg from '@/assets/images/onboarding/classlist.svg';
import ArrowRightSvg from '@/assets/images/onboarding/arrowright.svg';

export default {
  name: 'GradesDesktop',
  props: {
    value: {
      required: true,
    },
    isEmpty: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState('students', ['student']),

    teacherImage() {
      return TeacherSvg;
    },

    arrowRightImage() {
      return ArrowRightSvg;
    },

    onboardingStepText() {
      return `
        <div class="flex flex-col justify-center items-center">
          <img style="max-width: 155px" src="${this.teacherImage}"/>
          <h3 class="text-center">${this.$t('onboarding.grades.title')}</h3>
          <p class="text-center py-4 px-4 lg:px-8">${this.$t('onboarding.grades.content')}</p>
        </div>`;
    },
  },
  methods: {
    ...mapMutations('layout', ['showClassList', 'hideClassList']),
    ...mapActions('onboarding', ['setOnboardingProperty']),

    getDateWithYearlyOffset(years) {
      return moment().add(years, 'y').toDate();
    },

    closeOnboardingTag() {
    },

    acceptOnboardingTag() {
    },

    addArrow(tour) {
      const currentStepElement = tour.currentStep.el;
      const header = currentStepElement.querySelector('.shepherd-header');
      const progress = document.createElement('img');
      progress.classList.add('stepherd-custom-arrow--right');
      progress.src = `${this.arrowRightImage}`;
      header.insertBefore(
        progress,
        currentStepElement.querySelector('.shepherd-cancel-icon'),
      );
    },

    setTourCookie() {
      if (this.student?.id) {
        this.setOnboardingProperty({ deviceType: 'desktop', property: 'grades', value: true });
      }
    },

    startOnboarding() {
      this.$nextTick(() => {
        const vm = this;
        const tour = this.$shepherd({
          useModalOverlay: true,
          defaultStepOptions: {
            cancelIcon: {
              enabled: true,
            },
          },
        });

        vm.hideClassList();

        tour.addStep({
          text: vm.onboardingStepText,
          beforeShowPromise() {
            return new Promise((resolve) => {
              setTimeout(() => {
                window.scrollTo(0, 0);
                resolve();
              }, 500);
            });
          },
          attachTo: {
            element: this.isEmpty ? null : '.grades__list',
            on: this.isEmpty ? null : 'right-start',
          },
          canClickTarget: false,
          modalOverlayOpeningRadius: 12,
          popperOptions: {
            placement: 'right-start',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 270],
                },
              },
            ],
          },
          buttons: [
            {
              text: this.$t('onboarding.grades.btn'),
              action() {
                vm.acceptOnboardingTag();
                vm.$emit('input', !vm.value);
                vm.showClassList();
                vm.setTourCookie();
                return this.complete();
              },
            },
          ],
          when: {
            show() {
              if (!vm.isEmpty) {
                vm.addArrow(this.tour);
              }
            },
            cancel() {
              vm.closeOnboardingTag();
              vm.$emit('input', !vm.value);
              vm.showClassList();
            },
          },
        });

        tour.start();

        Event.$on('cancelTour', () => {
          tour.cancel();
        });
      });
    },
  },

  beforeDestroy() {
    Event.$off('cancelTour');
  },

  watch: {
    value(value) {
      if (value) {
        this.startOnboarding();
      }
    },
  },
};
</script>
